
import { Component, Vue, Watch } from "vue-property-decorator";
import { Loading, LoadingTemplateType, RigheDistintaList, RigheDistintaComunicazioneConsumi, RigheDistintaValidazioneConsumi } from "@/components";
import { Distinta } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';

@Component({
    components: {
        Loading,
        RigheDistintaList,
        RigheDistintaComunicazioneConsumi,
        RigheDistintaValidazioneConsumi
    }
})
export default class DistintaDettaglio extends Vue {
  
  private modoInvioConsumi = false;
  private modoValidazioneConsumi = false;
  get modoVisualizzazione() { return !this.modoInvioConsumi && !this.modoValidazioneConsumi; }
  
  get loading() { return store.state.loading; }

  get distinta(): Distinta | undefined { return store.state.distintaCorrente; }
    
  get loadTemplateCorrente() : LoadingTemplateType {
    return LoadingTemplateType.DistintaDettaglio;
  }

  private created() {
      // in caso di admin si parte direttamente dalla vista di validazione
      this.modoValidazioneConsumi = store.getters.isUserAdmin;
  }

  @Watch("$route.params.id", { immediate: true })
  async onIdChanged(newId: string, oldId: string) {

      // la distinta statica può essere caricata a partire dall'id interno, o dall'id composto (tripletta stagione-modello-colore).
      // In quest'ultimo caso si assume che la visualizzazione avvenga a partire da una lavorazione quindi, se l'utente è un fornitore,
      // si parte direttamente dalla visualizzazione per la comunicazione dei consumi
      const stagModCol = newId.split("-");
      if(stagModCol && stagModCol.length === 3) {
          const smc = {
              stagione: stagModCol[0],
              modello: stagModCol[1],
              colore: stagModCol[2]
          };
          await store.dispatch(StoreActions.GetDistintaStaticaDaStagioneModelloColore, smc);
          this.modoInvioConsumi = !store.getters.isUserAdmin;
      }
      else {
          await store.dispatch(StoreActions.GetDistintaStaticaDaIdConCorrelate, newId);
      }
      
      if(this.distinta) {
          store.commit(StoreMutations.SetSottotitoloPagina, this.distinta.id);
      }
  }

  private beforeDestroy() {
      // eventuale rilascio risorse e/o de-sottoscrizione notifiche
  }
}
